export const PrivacyPolicy = () => {
    return (
        <section className="container text-box">
            <h1>Privacy Policy</h1>
            <p>
                <strong>Effective date:</strong> 23 October 2025
            </p>
            <p>
                <strong>Last updated:</strong> 5 February 2026
            </p>

            <h2>1. Who We Are</h2>
            <p>
                This website is operated by{" "}
                <strong>Functional Adjustment SRL</strong>, a company registered
                in Romania under registration number
                <strong> CUI/Reg. No.: RO-47617895</strong>, with its registered
                office at
                <strong> 21st Grapei St., Cluj-Napoca, Cluj, Romania</strong>.
                You can contact us at{" "}
                <a href="mailto:privacy@tinkrverse.com">
                    privacy@tinkrverse.com
                </a>{" "}
                for any data related inquiries.
            </p>

            <h2>2. What Data We Collect</h2>
            <p>We collect only the following personal data:</p>
            <ul>
                <li>
                    <strong>Email address</strong> — when you voluntarily sign
                    up to unlock downloadable content, receive updates, or
                    subscribe to our communications..
                </li>

                <li>
                    <strong>Technical data</strong> — such as IP address,
                    browser type, and timestamps, collected automatically
                    through server logs for security and operational purposes.
                </li>

                <li>
                    <strong>Authentication data</strong> — including
                    verification tokens and access credentials stored via secure
                    cookies, used solely to grant access to restricted content
                </li>
            </ul>
            <p>
                <strong>Note:</strong> We do not use tracking or advertising
                cookies or sensitive personal data.
            </p>

            <h2>3. Purpose of Processing</h2>
            <p>We process personal data for the following purposes:</p>
            <ul>
                <li>
                    To provide access to downloadable content and project
                    resources;
                </li>
                <li>
                    To authenticate users and prevent unauthorized access or
                    abuse;
                </li>
                <li>
                    To send confirmation emails and service-related
                    communications;
                </li>
                <li>
                    To send updates or announcements only if you have opted in.
                </li>
            </ul>
            <p>
                We do <strong>not</strong> sell, rent, or share your personal
                data with third parties for marketing purposes.
            </p>

            <h2>4. Legal Basis</h2>
            <p>We process personal data based on:</p>
            <ul>
                <li>
                    <strong> Explicit consent</strong> under
                    <strong> Article 6(1)(a)</strong> of the General Data
                    Protection Regulation (GDPR) - for optional communications
                    and updates;
                </li>
                <li>
                    <strong> Performance of a service</strong> under
                    <strong> Article 6(1)(b)</strong> of the GDPR - to provide
                    access to requested content;
                </li>
                <li>
                    <strong> Legitimate interests</strong> under
                    <strong> Article 6(1)(f)</strong> of the GDPR - for security
                    logging, fraud prevention, and maintaining service
                    integrity.
                </li>
            </ul>

            <h2>5. Data Storage and Security</h2>
            <p>
                Personal data is stored and processed on secure servers located
                within the European Union.
            </p>
            <ul>
                <li>
                    Website hosting is provided by Hetzner Online GmbH
                    (Germany).
                </li>
                <li>Email delivery services are provided by Namecheap, Inc.</li>
            </ul>
            <p>
                We apply appropriate technical and organizational measures to
                protect your data, including:
            </p>
            <ul>
                <li>Encrypted connections (HTTPS / TLS)</li>
                <li>
                    Restricted access controls and least-privilege permissions;
                </li>
                <li>Regular system updates and security monitoring</li>
            </ul>
            <p>
                We do <strong>not</strong> transfer personal data outside the
                European Union.
            </p>

            <h2>6. Data Retention</h2>
            <p>We retain your email address until:</p>
            <ul>
                <li>You unsubscribe; or</li>
                <li>You request deletion; or</li>
                <li>We discontinue the newsletter/updates service.</li>
            </ul>

            <h2>7. Your Rights</h2>
            <p>Under the GDPR, you have the right to:</p>
            <ul>
                <li>Access your personal data;</li>
                <li>Request correction or deletion of your data;</li>
                <li>Withdraw consent at any time;</li>
                <li>Object to certain processing activities;</li>
                <li>Lodge a complaint with a supervisory authority.</li>
            </ul>
            <p>
                To exercise these rights, please contact us at{" "}
                <a href="mailto:privacy@tinkrverse.com">
                    privacy@tinkrverse.com
                </a>
                .
            </p>

            <h2>8. Changes to This Privacy Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. The revised
                version will be indicated by an updated "Last updated" date and
                will be effective as soon as it is accessible. We encourage you
                to review this policy periodically to stay informed about our
                data practices.
            </p>

            <p>
                By using our website, you acknowledge that you have read and
                understood this Privacy Policy.
            </p>

            <p>
                <strong>Note:</strong> We use <strong>essential cookies</strong>{" "}
                only to provide secure access and functionality. These cookies
                are required for the operation of the website and cannot be
                disabled.
            </p>
        </section>
    );
};
